/**
 * Sif Starter Theme - JavaScript du thème (sans CSS).
 *
 * Séparé de main.js pour qu'un thème enfant puisse inclure ce JS sans re-bundler le CSS du parent.
 */

// Theme JavaScript
console.log('[Sif Starter Theme] Loaded successfully');

// You can add your custom JavaScript here
// Example: Alpine.js, GSAP animations, custom interactions, etc.
